module.exports = __webpack_public_path__ + "img/thermometer-25.e0c22bb8.svg";